import { AlertTriangle, X } from 'lucide-preact'

interface ErrorModalProps {
  config: { title: string; message: string }
  onClose: () => void
}

export function ErrorModal({ config, onClose }: ErrorModalProps) {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={onClose} />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-lg bg-slate-800 shadow-xl">
          <div className="flex items-center justify-between p-6 pb-4">
            <div className="flex items-center space-x-3">
              <div className="rounded-full p-2 bg-yellow-900/20 border border-yellow-800">
                <AlertTriangle className="w-6 h-6 text-yellow-400" />
              </div>
              <h3 className="text-lg font-semibold text-slate-100">{config.title}</h3>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-slate-400 hover:text-slate-300 rounded-lg hover:bg-slate-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="px-6 pb-6">
            <p className="text-sm text-slate-300 leading-relaxed">{config.message}</p>
          </div>
          <div className="px-6 py-4 bg-slate-900 rounded-b-lg flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium rounded-lg bg-slate-600 hover:bg-slate-700 text-white transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
